/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum PolicyEngineType {
    corestack_policy = 'corestack_policy',
    aws_organization_policy = 'aws_organization_policy',
    azure_policy = 'azure_policy',
    aws_config = 'aws_config',
    gcp_organization_policy = 'gcp_organization_policy',
    gcp_policy = 'gcp_policy',
    kubernetes_policy = 'kubernetes_policy',
    oracle_cloud_guard = 'oracle_cloud_guard'
}
